import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { recoverySteps } from "@/mocks/site";

export default function RecoveryPath() {
  return (
    <section className="bg-background-50">
      <div className="max-w-editorial mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <SectionHeading
            eyebrow="恢复路径"
            title="从被围攻的那一天，到重新掌控生活"
            description="恢复不是一条直线。下列五个阶段来自亲历者回访中反复出现的共同经验，可根据自身状态灵活调整顺序。"
          />
          <Link
            to="/knowledge"
            className="shrink-0 inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看完整心理分析
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <ol className="mt-12 grid grid-cols-1 md:grid-cols-5 gap-6 md:gap-4">
          {recoverySteps.map((item) => (
            <li key={item.step} className="relative">
              <div className="flex items-center gap-3 md:block">
                <span className="shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-heading text-sm font-bold">
                  {item.step}
                </span>
                <span className="hidden md:block h-px flex-1 bg-background-300 mt-0 md:mt-4"></span>
              </div>
              <h3 className="mt-0 md:mt-5 font-heading text-base font-bold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}